// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/** Text color for old (removed/overwritten) values — red strikethrough. */
/** Text color for new (added/replacement) values — green. */
/** Row background for wholly new rows (component or valve added in this revision). */
/** Row background for wholly deleted rows (present in previous revision, absent in current). */
/** Text color for deleted row cells (dark red, pairs with \$compare-row-deleted-bg). */
/** Text color for new row cells (dark green, pairs with \$compare-row-new-bg). */
h2 {
  text-align: left;
}

.search-tips {
  margin: 10px 25px;
  color: #707070;
}

.add-search-results-to-workspace-button {
  background-color: #0066b2;
  color: #ffffff;
  border: none;
  padding: 0 20px;
  margin-right: auto;
  font-size: 14px;
  font-family: "GothamBold", Arial, sans-serif;
}

.add-search-results-to-workspace-button:hover {
  cursor: pointer;
  background-color: #0b2d71;
}

.container-horizontal {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.container-vertical, .filters-container {
  display: flex;
  flex-direction: column;
  flex-grow: 3;
}

.search-result-pane {
  flex: 3 100%;
  flex-basis: 100%;
  max-width: 75%;
}

.filters-container {
  width: 25%;
  max-width: 300px;
  margin-top: 10px;
  overflow-y: auto;
}

.filter-group * {
  justify-content: space-between;
}

.filter-group-item {
  padding-left: 24px;
  line-height: 40px;
  border: 1px solid rgb(237, 237, 238);
  border-radius: 3px;
}
.filter-group-item span {
  color: #0066b2;
  font-size: 12px;
  font-weight: bold;
}

.filter-group-heading {
  align-items: center;
  line-height: 40px;
  border: none;
  border-radius: 3px;
  font-weight: bolder;
  color: black;
  max-height: 40px;
}
.filter-group-heading p {
  margin-left: 10px;
}

.items-per-page {
  margin: 2%;
}

.mat-mdc-paginator-container > * {
  font-family: "Gotham", "Arial", sans-serif;
}

.mat-mdc-select-min-line {
  font-family: "Gotham", "Arial", sans-serif;
}

.reset {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.reset .text-button {
  font-size: 14px;
  padding-right: 4%;
}
.reset .small-filter-heading {
  font-size: 18px;
  margin-top: 10%;
  color: #0066b2;
  font-family: "GothamBold", Arial, sans-serif;
  font-weight: bolder;
}

.reset-lower {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.reset-lower .text-button {
  font-size: 14px;
  padding-right: 4%;
}

.type-filter-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.type-filter-container .type-sub-container {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.type-filter-container input {
  width: 15px;
  height: 15px;
}
.type-filter-container .checkbox-type-label {
  margin-left: 10px;
  font-size: 16px;
  font-weight: bolder;
}

.include-non-current-container {
  display: flex;
  align-items: center;
  margin: 12px 0 16px;
  padding-left: 6px;
}
.include-non-current-container .mat-mdc-slide-toggle label {
  font-size: 16px;
  font-weight: bolder;
  color: black;
}

.export-buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-right: 25px;
  margin-left: 25px;
}

.progress-bar-container {
  min-height: 6px;
  margin-top: 8px;
  margin-bottom: 8px;
  margin-right: 25px;
  margin-left: 25px;
}
.progress-bar-container .searching-progress-bar {
  height: 5px;
}

.spinner-message {
  display: flex;
  font-style: "Gotham", Arial, sans-serif;
  align-items: center;
}
.spinner-message .mat-mdc-progress-spinner {
  margin-right: 10px;
  margin-left: 10px;
}

.welding-procedure-preview-pane {
  top: 100px;
}

.horizontal-container-for-results-and-preview {
  display: flex;
  align-items: center;
  flex-grow: 3;
}

.filter-selection-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: flex-start;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  padding: 20px 25px;
}
.filter-selection-container .filter-selection-item {
  flex: 0 0 33%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 1%;
}
.filter-selection-container .chips-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
}
.filter-selection-container .chips-container mat-chip-option {
  border-radius: 5px;
  background-color: #0066b2;
}
.filter-selection-container .chips-container mat-chip-option span {
  color: white;
}
.filter-selection-container .chips-container button {
  color: white;
}

.temp-unit-container {
  margin: auto;
  display: flex;
  flex-direction: row;
}
.temp-unit-container .checkbox-container {
  margin-right: 25px;
}

.piping-panel {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1607843137);
  opacity: 1;
  margin: 32px 25px;
  padding: 12px 0;
}
.piping-panel .piping-title {
  display: flex;
  justify-content: space-between;
  margin-left: 2%;
  width: 95%;
  font-family: "GothamBold", Arial, sans-serif;
  font-weight: bold;
  font-size: 20px;
  letter-spacing: 0px;
  color: #0066b2;
}
.piping-panel .piping-subtitle {
  display: flex;
  width: 95%;
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  color: #0066b2;
  margin-left: 2%;
  margin-right: 2%;
}
.piping-panel .prop-label {
  font-family: "Gotham", Arial, sans-serif;
  font-weight: 100;
  font-size: 14px;
  text-align: left;
  letter-spacing: 0px;
  color: #8c8f93;
  opacity: 1;
  margin: 0;
  padding: 0;
}
.piping-panel .prop-value {
  font-family: "Gotham", Arial, sans-serif;
  font-size: 14px;
  font-weight: 100;
  text-align: left;
  color: #000000;
  margin: 0;
  padding: 0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
